// extracted by mini-css-extract-plugin
export var folderContainer = "mobileFolder-module--folderContainer--utLkk";
export var docs0 = "mobileFolder-module--docs0--mV+Dp";
export var docs1 = "mobileFolder-module--docs1--Z0aQA";
export var textContainer = "mobileFolder-module--textContainer--Gr1Qp";